import React from "react";
import FieldDateRange from "../../../../generic/datetime/date-range/date-range";
import FieldConfig from "../../../../proto/field-config";
import Project from "../../../../../model2/project/project";
import ItemModel from "../../../../../model2/item/item-model";
import TableManager from "../../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../../gd-modules/task-list/manager/manager";
import {LifecycleAction} from "../../../../../gd/const/lifecycle";
import {ViewType} from "../../../../../gd/const/views/view-type";
import GanttChartManager from "../../../../../gd-modules/gantt-chart/manager/manager";


export default class FieldProjectStartEnd extends FieldDateRange {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Start/End";
        this.icon               = 'i5-calendar';
        this.label              = _.get(config, 'label', "Project Start-End")

        this.components.ValueIcon   = <span className="ui5-ico-16 m-r-10 fl-no-shrink i5-calendar" />

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangeStartDate
    }


    tableCellOnValueChange = async (item:ItemModel, value: MomentRange|null, manager: TableManager|TaskListManager|GanttChartManager) => {

        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const newStartDate  = value ? value.start : null
                const newEndDate    = value ? value.end : null

                const ganttManager = manager as GanttChartManager
                ganttManager.setStartEnd(item.id, newStartDate, newEndDate)

                break

            default:
                if (!value) {
                    // jsut start is enough
                    item.task.updateStartDate(null)
                } else {
                    item.task.updateStartDate(value.start)
                    item.task.updateEndDate(value.end)
                }

                item.project.save()

                item._updateLastUpdateTime() // otherwise it wont re-render

                manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])
                break
        }

    }

}